var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _path8, _path9, _path10, _path11, _path12, _path13, _circle3, _circle4, _rect2, _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvestorBackground3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2165,
    height: 2257,
    viewBox: "0 0 2165 2257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2080,
    height: 2080,
    transform: "translate(85 177)",
    fill: "url(#paint0_linear_9046_48340)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M514.363 1460.31C520.418 1463.62 528.865 1467.2 530.373 1473.28L534.618 1497.83C535.711 1503.62 536.642 1507.29 536.27 1516.41C536.098 1519.15 534.679 1525.62 530.373 1529.6C524.99 1534.56 520.04 1539.62 492.838 1547.68C474.666 1553.06 441.232 1554.45 425.687 1552.02C391.726 1546.7 389.307 1545.29 376.034 1538.51C367.63 1534.21 363.071 1527.92 361.737 1524.5C358.438 1516.05 359.755 1507.43 361.21 1503.79C364.41 1495.79 371.46 1478.42 374.055 1472.91C376.65 1467.41 384.305 1463.36 387.808 1462.02",
    stroke: "white",
    strokeWidth: 1.11967
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M516.387 1475L519.281 1493.97C520.004 1502.32 518.565 1507.47 505.542 1515.42C488.895 1525.59 464.484 1526.28 449.127 1526.28C433.165 1526.28 409.359 1525.59 392.712 1515.42C379.689 1507.47 376.008 1504.29 378.973 1493.97L385.551 1475.66",
    stroke: "white",
    strokeWidth: 0.447866
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M388.887 1429.27C388.887 1452.78 388.838 1461.5 385.076 1479.05L400.41 1483.81C404.172 1466.26 404.086 1462.2 404.086 1438.68",
    stroke: "white",
    strokeWidth: 0.440528
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M513.065 1420.55C512.219 1445.09 513.456 1461.81 517.218 1479.36L501.884 1484.12C498.122 1466.57 497.98 1456.6 497.98 1433.09",
    stroke: "white",
    strokeWidth: 0.440528
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M442.917 880C491.258 880 538.237 911.705 538.237 977.975L538.544 1349.04C538.544 1415.31 492.005 1447.01 443.664 1447.01C410.064 1447.01 352.987 1423.47 352.987 1347.6L352 977.975C352 918.786 391.04 880 442.917 880Z",
    fill: "url(#paint1_linear_9046_48340)",
    stroke: "url(#paint2_linear_9046_48340)",
    strokeWidth: 2.23933
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M509.497 923.474L509.492 923.466L509.487 923.459C497.938 907.406 479.062 887.942 443.64 887.942C413.52 887.942 393.285 904.978 381.045 923.474C370.617 939.231 368.636 954.641 368.636 972.178V1357.48C368.636 1368.54 368.839 1378.58 375.719 1393.23C380.912 1404.29 388.67 1416.62 408.352 1428.09C416.706 1432.96 432 1438.01 444.062 1438.01H446.48C459.751 1438.01 473.69 1433.04 482.19 1428.09C501.872 1416.62 509.63 1404.29 514.823 1393.23C521.703 1378.58 521.906 1368.54 521.906 1357.48V972.178C521.906 954.641 519.925 939.231 509.497 923.474Z",
    fill: "url(#paint3_linear_9046_48340)",
    stroke: "url(#paint4_linear_9046_48340)",
    strokeWidth: 0.895732
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M494.264 1357.54V971.859C494.264 960.595 492.991 950.742 486.324 940.667C478.916 930.37 466.841 917.924 444.172 917.924C424.909 917.924 411.964 928.814 404.12 940.667C397.452 950.742 396.18 960.595 396.18 971.859V1357.54C396.18 1364.64 396.31 1371.05 400.712 1380.42C404.035 1387.5 408.994 1395.39 421.602 1402.74C426.943 1405.85 436.738 1409.09 444.444 1409.09H446C454.481 1409.09 463.404 1405.91 468.841 1402.74C481.45 1395.39 486.408 1387.5 489.732 1380.42C494.133 1371.05 494.264 1364.64 494.264 1357.54Z",
    fill: "url(#paint5_linear_9046_48340)",
    stroke: "url(#paint6_linear_9046_48340)",
    strokeWidth: 0.895732
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 445.218,
    cy: 1361.42,
    r: 43.4096,
    stroke: "white",
    strokeWidth: 0.110132
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 445.272,
    cy: 1361.42,
    r: 13.1057,
    stroke: "white",
    strokeWidth: 0.220264
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M530.372 1516.19C534.678 1512.21 535.418 1505.75 535.59 1503.01C536.173 1507.35 536.674 1510.52 536.319 1516.19C536.147 1518.93 534.678 1525.43 530.372 1529.41C524.99 1534.37 520.04 1539.43 492.837 1547.49C474.665 1552.87 441.579 1553.76 426.143 1551.85C417.596 1550.79 412.504 1550.21 403.42 1548.35C381.798 1543.93 371.268 1535.7 365.885 1530.73C361.579 1526.76 360.11 1520.25 359.939 1517.52C359.584 1511.85 360.085 1508.68 360.668 1504.33C360.839 1507.07 361.579 1513.54 365.885 1517.52C371.268 1522.48 376.218 1527.54 403.42 1535.6C407.745 1536.88 417.371 1538.61 426.143 1539.47C447.784 1541.59 474.665 1539.66 492.837 1534.27C520.04 1526.21 524.99 1521.16 530.372 1516.19Z",
    fill: "url(#paint7_linear_9046_48340)",
    stroke: "white",
    strokeWidth: 1.11967
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M455.086 982.583C455.086 984.83 454.645 987.056 453.788 989.131C452.93 991.207 451.674 993.093 450.09 994.682C448.505 996.271 446.625 997.531 444.555 998.39C442.486 999.249 440.268 999.691 438.028 999.69V992.454C439.8 992.471 441.547 992.031 443.102 991.177C444.602 990.354 445.847 989.133 446.702 987.648C447.559 986.116 448.009 984.389 448.009 982.632C448.009 980.875 447.559 979.148 446.702 977.616C445.848 976.132 444.602 974.914 443.102 974.096C441.524 973.263 439.768 972.827 437.985 972.827C436.202 972.827 434.445 973.263 432.868 974.096C431.372 974.909 430.131 976.122 429.281 977.601C428.681 978.639 428.282 979.782 428.106 980.969C425.521 979.302 423.394 977.01 421.921 974.303C420.448 971.597 419.676 968.562 419.677 965.479H438.028C440.268 965.477 442.486 965.919 444.555 966.778C446.625 967.637 448.505 968.897 450.089 970.485C451.674 972.074 452.93 973.96 453.788 976.036C454.645 978.112 455.086 980.336 455.086 982.583Z",
    fill: "url(#paint8_angular_9046_48340)",
    stroke: "url(#paint9_angular_9046_48340)",
    strokeWidth: 0.635595
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M455.084 968.082V960.237H468.135L455.084 968.082Z",
    fill: "url(#paint10_angular_9046_48340)",
    stroke: "white",
    strokeWidth: 0.635595
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M455.083 956.285V960.237H441.963C441.446 960.237 440.933 960.136 440.455 959.937C439.977 959.739 439.543 959.448 439.177 959.081C438.811 958.714 438.52 958.278 438.322 957.798C438.124 957.318 438.022 956.804 438.021 956.285V952.333H451.142C451.659 952.332 452.171 952.434 452.648 952.633C453.126 952.831 453.56 953.122 453.925 953.489C454.291 953.856 454.581 954.292 454.779 954.772C454.977 955.251 455.078 955.765 455.078 956.285",
    fill: "url(#paint11_angular_9046_48340)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M455.083 956.285V960.237H441.963C441.446 960.237 440.933 960.136 440.455 959.937C439.977 959.739 439.543 959.448 439.177 959.081C438.811 958.714 438.52 958.278 438.322 957.798C438.124 957.318 438.022 956.804 438.021 956.285V952.333H451.142C451.659 952.332 452.171 952.434 452.648 952.633C453.126 952.831 453.56 953.122 453.925 953.489C454.291 953.856 454.581 954.292 454.779 954.772C454.977 955.251 455.078 955.765 455.078 956.285",
    stroke: "white",
    strokeWidth: 0.635595
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M441.362 986.297C440.471 987.231 439.337 987.702 437.958 987.71H437.924C436.529 987.71 435.383 987.239 434.486 986.297C433.704 985.468 433.238 984.377 433.17 983.223C433.154 983.035 433.146 982.843 433.146 982.645C433.146 981.153 433.594 979.936 434.491 978.994C435.388 978.053 436.534 977.581 437.929 977.58C439.324 977.58 440.47 978.051 441.367 978.994C442.264 979.937 442.712 981.154 442.712 982.645C442.709 984.14 442.259 985.358 441.362 986.297Z",
    fill: "url(#paint12_angular_9046_48340)",
    stroke: "url(#paint13_angular_9046_48340)",
    strokeWidth: 0.635595
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 445.221,
    cy: 1361.42,
    r: 23.901,
    stroke: "url(#paint14_angular_9046_48340)",
    strokeWidth: 3.17798
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 445.272,
    cy: 1361.42,
    r: 12.656,
    fill: "url(#paint15_angular_9046_48340)",
    stroke: "white",
    strokeWidth: 1.11967
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 253.748,
    height: 275.622,
    transform: "translate(388 1227)",
    fill: "url(#paint16_radial_9046_48340)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.936 807.056C829.936 818.871 827.382 830.57 822.42 841.485C817.459 852.399 810.186 862.316 801.018 870.669C791.85 879.021 780.966 885.646 768.988 890.164C757.01 894.682 744.173 897.005 731.21 897V858.952C741.468 859.043 751.579 856.732 760.575 852.239C769.256 847.912 776.465 841.494 781.414 833.685C786.373 825.63 788.977 816.548 788.977 807.312C788.977 798.075 786.373 788.994 781.414 780.938C776.471 773.137 769.26 766.732 760.575 762.43C751.443 758.05 741.279 755.762 730.959 755.762C720.64 755.762 710.476 758.05 701.343 762.43C692.689 766.707 685.503 773.086 680.583 780.858C677.112 786.317 674.806 792.327 673.788 798.569C658.822 789.803 646.512 777.751 637.988 763.521C629.463 749.29 624.998 733.336 625 717.122H731.21C744.173 717.116 757.01 719.438 768.987 723.955C780.965 728.472 791.849 735.096 801.017 743.447C810.185 751.799 817.458 761.715 822.42 772.63C827.382 783.544 829.936 795.242 829.936 807.056Z",
    fill: "url(#paint17_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.926 730.809V689.564H905.461L829.926 730.809Z",
    fill: "url(#paint18_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.92 668.779V689.558H753.983C750.989 689.562 748.024 689.027 745.258 687.984C742.491 686.942 739.977 685.412 737.858 683.482C735.74 681.553 734.059 679.261 732.912 676.738C731.764 674.215 731.173 671.511 731.172 668.779V648H807.109C810.1 647.999 813.063 648.535 815.826 649.579C818.59 650.623 821.102 652.153 823.217 654.083C825.333 656.013 827.011 658.304 828.156 660.825C829.301 663.347 829.89 666.05 829.89 668.779",
    fill: "url(#paint19_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.498 826.582C745.344 831.492 738.779 833.967 730.801 834.009H730.601C722.528 834.009 715.896 831.533 710.704 826.582C706.18 822.223 703.478 816.487 703.088 810.419C702.993 809.429 702.945 808.422 702.945 807.379C702.945 799.533 705.541 793.135 710.733 788.184C715.924 783.233 722.557 780.755 730.63 780.749C738.703 780.749 745.335 783.227 750.527 788.184C755.718 793.141 758.314 799.539 758.314 807.379C758.295 815.242 755.69 821.643 750.498 826.582Z",
    fill: "url(#paint20_angular_9046_48340)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.242 264.847C606.242 284.52 601.989 303.999 593.727 322.174C585.465 340.348 573.355 356.861 558.089 370.768C542.823 384.676 524.7 395.707 504.756 403.23C484.812 410.753 463.437 414.621 441.852 414.613V351.259C458.932 351.411 475.768 347.562 490.748 340.081C505.202 332.876 517.205 322.189 525.447 309.187C533.703 295.774 538.039 280.652 538.039 265.272C538.039 249.893 533.703 234.771 525.447 221.358C517.217 208.367 505.208 197.702 490.748 190.539C475.542 183.246 458.617 179.435 441.434 179.435C424.251 179.435 407.326 183.246 392.12 190.539C377.71 197.661 365.745 208.282 357.552 221.223C351.772 230.314 347.932 240.321 346.237 250.714C321.318 236.118 300.821 216.051 286.626 192.355C272.432 168.659 264.996 142.093 265 115.096H441.852C463.436 115.086 484.811 118.953 504.755 126.474C524.699 133.995 542.822 145.024 558.088 158.931C573.354 172.837 585.464 189.349 593.727 207.523C601.989 225.696 606.242 245.175 606.242 264.847Z",
    fill: "url(#paint21_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.225 137.886V69.2095H732L606.225 137.886Z",
    fill: "url(#paint22_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.215 34.5996V69.1992H479.77C474.786 69.2051 469.85 68.3146 465.243 66.5786C460.636 64.8427 456.449 62.2953 452.922 59.082C449.394 55.8687 446.595 52.0526 444.685 47.8518C442.775 43.6509 441.79 39.1478 441.788 34.5996V3.22839e-06H568.232C573.213 -0.00196003 578.145 0.891522 582.747 2.62944C587.35 4.36735 591.531 6.91561 595.054 10.1287C598.577 13.3417 601.371 17.1566 603.278 21.3554C605.184 25.5542 606.165 30.0547 606.165 34.5996",
    fill: "url(#paint23_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.969 297.36C465.387 305.534 454.455 309.656 441.171 309.726H440.838C427.396 309.726 416.352 305.604 407.707 297.36C400.175 290.1 395.675 280.55 395.026 270.446C394.867 268.798 394.788 267.121 394.788 265.384C394.788 252.32 399.11 241.666 407.755 233.423C416.4 225.179 427.443 221.052 440.886 221.042C454.328 221.042 465.372 225.169 474.016 233.423C482.661 241.676 486.983 252.33 486.983 265.384C486.951 278.477 482.613 289.136 473.969 297.36Z",
    fill: "url(#paint24_angular_9046_48340)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822.936 1678.06C822.936 1689.87 820.382 1701.57 815.42 1712.48C810.459 1723.4 803.186 1733.32 794.018 1741.67C784.85 1750.02 773.966 1756.65 761.988 1761.16C750.01 1765.68 737.173 1768 724.21 1768V1729.95C734.468 1730.04 744.579 1727.73 753.575 1723.24C762.256 1718.91 769.465 1712.49 774.414 1704.69C779.373 1696.63 781.977 1687.55 781.977 1678.31C781.977 1669.08 779.373 1659.99 774.414 1651.94C769.471 1644.14 762.26 1637.73 753.575 1633.43C744.443 1629.05 734.279 1626.76 723.959 1626.76C713.64 1626.76 703.476 1629.05 694.343 1633.43C685.689 1637.71 678.503 1644.09 673.583 1651.86C670.112 1657.32 667.806 1663.33 666.788 1669.57C651.822 1660.8 639.512 1648.75 630.988 1634.52C622.463 1620.29 617.998 1604.34 618 1588.12H724.21C737.173 1588.12 750.01 1590.44 761.987 1594.96C773.965 1599.47 784.849 1606.1 794.017 1614.45C803.185 1622.8 810.458 1632.72 815.42 1643.63C820.382 1654.54 822.936 1666.24 822.936 1678.06Z",
    fill: "url(#paint25_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.926 1601.81V1560.56H898.461L822.926 1601.81Z",
    fill: "url(#paint26_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.92 1539.78V1560.56H746.983C743.989 1560.56 741.024 1560.03 738.258 1558.98C735.491 1557.94 732.977 1556.41 730.858 1554.48C728.74 1552.55 727.059 1550.26 725.912 1547.74C724.764 1545.22 724.173 1542.51 724.172 1539.78V1519H800.109C803.1 1519 806.063 1519.54 808.826 1520.58C811.59 1521.62 814.102 1523.15 816.217 1525.08C818.333 1527.01 820.011 1529.3 821.156 1531.83C822.301 1534.35 822.89 1537.05 822.89 1539.78",
    fill: "url(#paint27_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.498 1697.58C738.344 1702.49 731.779 1704.97 723.801 1705.01H723.601C715.528 1705.01 708.896 1702.53 703.704 1697.58C699.18 1693.22 696.478 1687.49 696.088 1681.42C695.993 1680.43 695.945 1679.42 695.945 1678.38C695.945 1670.53 698.541 1664.14 703.733 1659.18C708.924 1654.23 715.557 1651.75 723.63 1651.75C731.703 1651.75 738.335 1654.23 743.527 1659.18C748.718 1664.14 751.314 1670.54 751.314 1678.38C751.295 1686.24 748.69 1692.64 743.498 1697.58Z",
    fill: "url(#paint28_angular_9046_48340)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.679 1503.04C163.679 1512.47 161.639 1521.82 157.676 1530.53C153.713 1539.25 147.905 1547.17 140.582 1553.84C133.26 1560.51 124.567 1565.8 115.001 1569.41C105.434 1573.02 95.1816 1574.88 84.8282 1574.87V1544.48C93.0208 1544.56 101.097 1542.71 108.282 1539.12C115.215 1535.67 120.972 1530.54 124.925 1524.3C128.885 1517.87 130.965 1510.62 130.965 1503.24C130.965 1495.86 128.885 1488.61 124.925 1482.18C120.978 1475.94 115.218 1470.83 108.282 1467.39C100.988 1463.9 92.8698 1462.07 84.6279 1462.07C76.386 1462.07 68.2679 1463.9 60.9742 1467.39C54.062 1470.81 48.3229 1475.9 44.3934 1482.11C41.6207 1486.47 39.7791 1491.27 38.966 1496.26C27.0133 1489.26 17.1816 1479.63 10.3733 1468.26C3.56491 1456.9 -0.00198919 1444.16 8.32235e-07 1431.21H84.8282C95.1812 1431.2 105.434 1433.06 115 1436.66C124.567 1440.27 133.259 1445.56 140.582 1452.23C147.904 1458.9 153.713 1466.82 157.676 1475.54C161.639 1484.26 163.679 1493.6 163.679 1503.04Z",
    fill: "url(#paint29_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.671 1442.14V1409.2H224L163.671 1442.14Z",
    fill: "url(#paint30_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.666 1392.6V1409.19H103.016C100.626 1409.19 98.2578 1408.77 96.048 1407.93C93.8383 1407.1 91.8301 1405.88 90.1381 1404.34C88.4462 1402.8 87.1037 1400.97 86.1874 1398.95C85.271 1396.94 84.7989 1394.78 84.7979 1392.6V1376H145.448C147.837 1376 150.203 1376.43 152.41 1377.26C154.617 1378.09 156.623 1379.32 158.313 1380.86C160.003 1382.4 161.343 1384.23 162.257 1386.24C163.172 1388.26 163.643 1390.42 163.643 1392.6",
    fill: "url(#paint31_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.233 1518.63C96.1174 1522.55 90.8735 1524.53 84.5018 1524.56H84.3421C77.8943 1524.56 72.5972 1522.58 68.4507 1518.63C64.8378 1515.15 62.6793 1510.57 62.3679 1505.72C62.2919 1504.93 62.2539 1504.13 62.2539 1503.29C62.2539 1497.03 64.3271 1491.92 68.4736 1487.96C72.62 1484.01 77.9171 1482.03 84.3649 1482.02C90.8127 1482.02 96.1098 1484 100.256 1487.96C104.403 1491.92 106.476 1497.03 106.476 1503.29C106.461 1509.57 104.38 1514.69 100.233 1518.63Z",
    fill: "url(#paint32_angular_9046_48340)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.139 808.84C215.139 818.187 213.118 827.443 209.192 836.078C205.267 844.714 199.513 852.56 192.259 859.168C185.006 865.776 176.395 871.017 166.918 874.592C157.442 878.166 147.286 880.004 137.03 880V849.898C145.145 849.97 153.145 848.141 160.262 844.587C167.13 841.163 172.834 836.085 176.749 829.908C180.672 823.535 182.733 816.35 182.733 809.042C182.733 801.735 180.672 794.549 176.749 788.176C172.839 782.004 167.133 776.937 160.262 773.533C153.037 770.068 144.996 768.257 136.831 768.257C128.667 768.257 120.625 770.068 113.4 773.533C106.553 776.917 100.868 781.963 96.9756 788.112C94.229 792.432 92.4047 797.186 91.5992 802.125C79.7591 795.189 70.0199 785.655 63.2756 774.396C56.5314 763.137 52.998 750.515 53 737.687H137.03C147.285 737.682 157.441 739.519 166.918 743.093C176.394 746.667 185.005 751.907 192.259 758.515C199.512 765.122 205.266 772.968 209.192 781.603C213.118 790.238 215.139 799.493 215.139 808.84Z",
    fill: "url(#paint33_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.13 748.516V715.884H274.891L215.13 748.516Z",
    fill: "url(#paint34_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.126 699.44V715.88H155.047C152.679 715.882 150.333 715.459 148.144 714.634C145.955 713.81 143.966 712.599 142.29 711.072C140.614 709.546 139.284 707.732 138.376 705.736C137.469 703.74 137.001 701.601 137 699.44V683H197.079C199.446 682.999 201.789 683.424 203.976 684.249C206.162 685.075 208.149 686.286 209.823 687.813C211.497 689.339 212.825 691.152 213.731 693.147C214.636 695.142 215.103 697.28 215.103 699.44",
    fill: "url(#paint35_angular_9046_48340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.29 824.288C148.213 828.172 143.018 830.131 136.706 830.164H136.548C130.161 830.164 124.914 828.205 120.806 824.288C117.228 820.839 115.089 816.301 114.781 811.5C114.706 810.717 114.668 809.92 114.668 809.095C114.668 802.888 116.722 797.826 120.829 793.909C124.937 789.992 130.184 788.031 136.571 788.026C142.958 788.026 148.205 789.987 152.313 793.909C156.42 797.831 158.474 802.893 158.474 809.095C158.459 815.316 156.397 820.381 152.29 824.288Z",
    fill: "url(#paint36_angular_9046_48340)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9046_48340",
    x1: 1040,
    y1: 0,
    x2: 1040,
    y2: 2080,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6941C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E77ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9046_48340",
    x1: 445.272,
    y1: 880,
    x2: 445.272,
    y2: 1447.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9046_48340",
    x1: 445.272,
    y1: 880,
    x2: 445.272,
    y2: 1447.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9046_48340",
    x1: 445.271,
    y1: 856.771,
    x2: 445.271,
    y2: 1478.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807292,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9046_48340",
    x1: 445.271,
    y1: 888.39,
    x2: 445.271,
    y2: 1437.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9046_48340",
    x1: 445.222,
    y1: 907.686,
    x2: 445.222,
    y2: 1409.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9046_48340",
    x1: 445.222,
    y1: 917.924,
    x2: 445.222,
    y2: 1409.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9046_48340",
    x1: 448.129,
    y1: 1503.01,
    x2: 448.129,
    y2: 1552.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(437.381 982.228) rotate(90) scale(17.4623 18.0738)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636628,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825424,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.940891,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(437.381 982.228) rotate(90) scale(17.4623)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328138,
    stopColor: "white",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53115,
    stopColor: "white",
    stopOpacity: 0.52598
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(461.61 964.078) rotate(90) scale(4.00397 6.66166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(446.552 956.202) rotate(90) scale(4.03443 8.7088)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(437.929 982.539) rotate(90) scale(5.1704 4.88309)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(437.929 982.539) rotate(90) scale(5.1704 4.88309)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(445.221 1360.88) rotate(90) scale(26.0213)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(445.272 1361.42) rotate(90) scale(13.2158)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662237,
    stopColor: "white",
    stopOpacity: 0.344949
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.874 137.811) rotate(90) scale(137.811 126.874)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(727.468 805.186) rotate(90) scale(91.8136 104.604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636628,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825424,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.940891,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(867.694 709.757) rotate(90) scale(21.0521 38.5551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(780.546 668.346) rotate(90) scale(21.2123 50.4032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(730.63 806.824) rotate(90) scale(27.185 28.2614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(435.621 261.733) rotate(90) scale(152.88 174.177)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636628,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825424,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.940891,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(669.112 102.832) rotate(90) scale(35.0542 64.1985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(524.001 33.8784) rotate(90) scale(35.3208 83.9269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(440.886 264.459) rotate(90) scale(45.266 47.0584)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(720.468 1676.19) rotate(90) scale(91.8136 104.604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636628,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825424,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.940891,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(860.694 1580.76) rotate(90) scale(21.0521 38.5551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(773.546 1539.35) rotate(90) scale(21.2123 50.4032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(723.63 1677.82) rotate(90) scale(27.185 28.2614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.8396 1501.54) rotate(90) scale(73.33 83.5455)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636628,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825424,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.940891,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(193.835 1425.32) rotate(90) scale(16.814 30.7933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.232 1392.25) rotate(90) scale(16.9419 40.2562)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.3649 1502.85) rotate(90) scale(21.7122 22.5719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.069 807.36) rotate(90) scale(72.6398 82.7591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636628,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825424,
    stopColor: "white",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.940891,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(245.011 731.86) rotate(90) scale(16.6557 30.5035)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(176.063 699.097) rotate(90) scale(16.7824 39.8773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_angular_9046_48340",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(136.571 808.656) rotate(90) scale(21.5078 22.3595)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorBackground3);
export default __webpack_public_path__ + "static/media/InvestorBackground3.922f07d10a82af7e2ff4e919a3130f2d.svg";
export { ForwardRef as ReactComponent };